import { Direction, Format, Variant, VariantVersion } from '.';
import { DocumentTypeEntity } from './distribution-object';

export class DocumentConfig {
    DocumentConfigsId: number;
    Description: string;
    DistributionObject: DocumentTypeEntity;
    Format: Format;
    Variant: Variant;
    VariantVersion: VariantVersion;
    Direction: Direction;
}

